import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import queryClient from '../query-client';
import { WorksheetSchema } from '../types/custom-worksheet-v2';
import { Entity } from '../types/entity';

export type UpdateWorksheetSchemaParams = {
    schema: WorksheetSchema;
};

/**
 * Updates the schema of a custom worksheet.
 * @param workpaperId - The ID of the workpaper that contains the worksheet.
 * @param worksheetId - The ID of the worksheet to update.
 * @param req - The request body containing the updated schema.
 */
async function updateCalculationSchema(
    workpaperId: string,
    calculationId: string,
    req: UpdateWorksheetSchemaParams
): Promise<{ entity: Entity }> {
    const { data } = await api.put(`/workpapers/${workpaperId}/worksheets/calculations/${calculationId}/schema`, { schema: req.schema });
    return data;
}

export function useUpdateCalculationSchema(calculationId: string): UseMutationResult<{}, AxiosError, UpdateWorksheetSchemaParams, unknown> {
    const { id } = useWorkpaperContext();
    return useMutation((req: UpdateWorksheetSchemaParams) => updateCalculationSchema(id, calculationId, req), {
        mutationKey: 'updateCustomWorksheetSchema',
        onSettled: () => {
            queryClient.invalidateQueries(['worksheets']);
            queryClient.invalidateQueries(['entries']);
        },
    });
}
